module.exports = __webpack_public_path__ + "img/product-picture.241b90f1.png";